export const TEXT_DISPLAY_THRESHOLD = 65
export const DEFAULT_SHELL_HEIGHT = 136
